import {TableTheme} from "@dv5/domain"
import React, {FC, useMemo} from "react"
import {parseCsv} from "../../services/csvParser"
import './TableViewer.less'

interface Props {
    sourceCode: string
    theme: TableTheme
}

export const TableViewer: FC<Props> = ({sourceCode, theme}) => {
    const {rows, error} = useMemo(() => parseCsv(sourceCode), [sourceCode])

    const renderEmpty = () => <div className='table-viewer__empty'/>

    if (error) {
        return (
            <div className={'table-viewer table-viewer--' + theme}>
                <div className='table-viewer__error'>{error}</div>
            </div>
        )
    }

    if (rows.length === 0) {
        return (
            <div className={'table-viewer table-viewer--' + theme}>
                {renderEmpty()}
            </div>
        )
    }

    const headerRow = rows[0]
    const bodyRows = rows.slice(1)

    return (
        <div className={'table-viewer table-viewer--' + theme}>
            <table className='table-viewer__table'>
                <thead>
                <tr>
                    {headerRow.map((cell, index) => (
                        <th key={index} className='table-viewer__cell table-viewer__cell--header'>{cell}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {bodyRows.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                            <td key={cellIndex} className='table-viewer__cell'>{cell}</td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
}
